module.exports = __webpack_public_path__ + "img/alex_situations_grey.3e9cfba7.svg";